module.exports = __webpack_public_path__ + "static/img/ver-5.1a079deb.png";